
// import Notice from "~/components/home/notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/applicationIntroduction/cend0.png`),
        }
      ],
      imgUrl:require(`@/static/images/technology/001_zh.png`),
      cEnd1Png: require(`@/static/images/applicationIntroduction/cend1${this.$i18n.locale == 'en' ? '_en' : '_zh'}.png`),
      cEnd2Png: require(`@/static/images/applicationIntroduction/cend2${this.$i18n.locale == 'en' ? '_en' : '_zh'}.png`),
      // cEnd3Png: require(`@/static/images/applicationIntroduction/cend3${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
      // cEnd4Png: require(`@/static/images/applicationIntroduction/cend4${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
      // c_intro_3: require(`@/static/images/applicationIntroduction/c_intro_3${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
      // c_intro_4: require(`@/static/images/applicationIntroduction/c_intro_4${this.$i18n.locale == 'en' ? '_en' : ''}.png`)
    }
  },
  computed: {
    contentList1() {
      let data = this.$t('Applicationintroduction.Cend.contentList');
      return data;
    }
  }
}
